export const pipe =
  (...functions) =>
  (target) =>
    functions && functions.reduce((acc, f) => f(acc), target);
